<template>
	<div>
		<div class="content">
			<Breadcrumb :pathList="pathList"></Breadcrumb>
			<div class="cont">
				<img src="../../assets/images/yqBg.png" style="width: 100%;height: 411px;" alt="" />
				<div class="flex flex-c-c" v-if="!loginUser.invite_user">
					<div class="bind">您未输入过他人邀请码，可 <span class="pointer" style="font-weight:600;"
							@click="inviteCode=true">点击此处 ></span> 绑定推荐人</div>
				</div>
				<div class="bg">
					<div class="flex-column-item">
						<img src="../../assets/images/mine/yqm.png" style="width: 160px;height: 23px;"></img>
						<div class="code">{{loginUser.invite_code}}</div>
						<!-- <div class="ewm"></div> -->
						<!-- <div ref="qrcodeContainer" class="ewm"></div> -->
						<img :src="inviteImgUrl" style="width: 268px;height: 268px;"/>
						<img @click="openDialog()" class="pointer" src="../../assets/images/mine/share.png"
							style="width: 150px;height: 50px;"></img>
					</div>
					<div class="tip">
						<div class="tit">规则说明</div>
						<div class="t" v-html="ruleData.content"></div>
					</div>
					<div class="flex-column-item" style="margin-top: 50px;">
						<img src="../../assets/images/mine/yqlist.png" style="width: 178px;height: 23px;"></img>
					</div>
					<div class="flex yq">您已成功邀请<span>{{count}}人</span></div>
					<div class="flex flex-b nitem" v-for="(item,i) in inviteList" :key="i">
						<div class="number">手机号：{{item.phone}}</div>
						<div class="number2">+{{item.score}}<span>积分</span></div>
					</div>
				</div>
			</div>
			<toTop></toTop>
		</div>
		<div class="inviteBg">
			<el-dialog :visible.sync="showShare" width="438px" center :show-close="false">
				<div class="shareBg flex-column-item" ref="posterContainer">
					<div class="ewm flex-column-item">
						<!-- <div ref="qrcodeContainer1"></div> -->
						<img :src="inviteImgUrl" style="width: 268px;height: 268px;"/>
					</div>
					<div class="downbtn pointer" @click="generatePoster">
						<img src="../../assets/images/mine/ic_pic.png"
							style="width: 18px;height: 18px;margin-right: 9px;" />
						<span>下载</span>
					</div>
				</div>
			</el-dialog>
			
			<el-dialog :visible.sync="inviteCode" width="438px" :close-on-click-modal='false' :show-close="true"
				:close-on-press-escape='false'>
				<div class="codeBox flex-column-item">
					<div class="tit">推荐人邀请码</div>
					<input v-model="code" type="text" placeholder="请输入6位邀请码" />
					<div class="login-btn pointer" style="margin-top: 10px;" @click="setInviteClick">
						<span class="text">确 定</span>
					</div>
				</div>
			</el-dialog>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import html2canvas from 'html2canvas';
	import QRCode from 'qrcodejs2'; // 引入二维码库
	import Utils from "@/jslibs/utils";
	import { imgDomain } from '@/configs/env';
	import {
		getUser,
		getMyInvite,
	} from '@/api/mine';
	import {
		setInvite
	} from '@/api/common';
	import {
		getConfigDetail,
		getConfigList,
		getFetchQRCode
	} from '@/api/common';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import Footer from '../../components/Footer.vue'
	import toTop from '../../components/toTop.vue'
	export default {
		data() {
			return {
				imgDomain,
				pathList: [{
					title: '我的',
					path: '/mine'
				}, {
					title: '邀请好友',
					path: ''
				}, ],
				showShare: false,
				inviteCode: false,
				loginUser: '',
				ruleData: '',
				count: 0,
				inviteList: [],
				code: '',
				qrContent: '', // 需要编码的内容
				qrCodeInstance: null ,// 用于保存二维码实例
				inviteImgUrl:''
			}
		},
		components: {
			Breadcrumb,
			Footer,
			toTop
		},
		mounted() {
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
			this.getConfigDetail()
			this.getMyInvite()
		},
		beforeDestroy() {
			// 组件销毁前最好清理实例
			if (this.qrCodeInstance) {
				this.qrCodeInstance.clear();
			}
		},
		methods: {
			async generatePoster() {
				try {
					// 获取海报DOM元素
					const posterElement = this.$refs.posterContainer;
					// 使用html2canvas将DOM转换为canvas
					const canvas = await html2canvas(posterElement, {
						useCORS: true, // 允许加载跨域图片（重要！）
						scale: 2, // 提升图片清晰度（可选）
						backgroundColor: null // 背景设为透明（可选）
					});
					// 将canvas转换为图片数据URL
					const imageUrl = canvas.toDataURL('image/png');

					// 创建隐藏的下载链接并触发点击
					const link = document.createElement('a');
					link.href = imageUrl;
					link.download = this.loginUser.name + '.png'; // 设置下载的文件名
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

				} catch (error) {
					console.error('生成海报失败:', error);
				}
			},
			generateQRCode() {
				// 生成前先清空容器，避免重复生成
				this.$refs.qrcodeContainer.innerHTML = '';

				this.qrCodeInstance = new QRCode(this.$refs.qrcodeContainer, {
					text: 'https://academy-pc.gymooit.cn/#/login?shareInviteCode='+this.qrContent, // 二维码内容
					width: 200, // 宽度
					height: 200, // 高度
					colorDark: "#000000", // 二维码颜色
					colorLight: "#ffffff", // 背景色
					correctLevel: QRCode.CorrectLevel.H // 容错级别
				});
			},
			openDialog() {
				this.showShare = true
				this.$nextTick(() => {
					this.$refs.qrcodeContainer1.innerHTML = '';

					this.qrCodeInstance = new QRCode(this.$refs.qrcodeContainer1, {
						text: this.qrContent, // 二维码内容
						width: 268, // 宽度
						height: 268, // 高度
						colorDark: "#000000", // 二维码颜色
						colorLight: "#ffffff", // 背景色
						correctLevel: QRCode.CorrectLevel.H // 容错级别
					});
				})
			},
			clearQrCode() {
				// 清除二维码
				this.$refs.qrcodeContainer.innerHTML = '';
			},
			async setInviteClick() {
				if (!this.code) {
					this.$message({
						message: "请填写邀请码",
						type: "warning"
					});
					return
				}
				const {
					status,
					data
				} = await setInvite({
					code: this.code
				})
				if (data.result) {
					this.$message({
						message: "绑定成功",
						type: "success"
					});
					this.inviteCode = false
					this.code = ''
					this.getUser()
				}
			},
			async getMyInvite() {
				const {
					status,
					data
				} = await getMyInvite({
					page_index: 1,
					page_size: 9999
				})
				this.inviteList = data.result.data
				this.count = data.result.total
			},
			async getConfigDetail() {
				const {
					status,
					data
				} = await getConfigDetail({
					key: 'INVITE'
				})
				this.ruleData = data.result
			},
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = data.result
				this.qrContent = this.loginUser.invite_code
				// this.generateQRCode()
				this.getFetchQRCode()
			},
			async getFetchQRCode(){
				const {
					status,
					data
				} = await getFetchQRCode({
					path:'/pages/login/login?invite_code='+this.loginUser.invite_code
				})
				this.inviteImgUrl = imgDomain+data.result
			},
		}
	}
</script>

<style lang="less" scoped>
	.content {
		padding: 30px 133px 0;

		.cont {
			padding: 20px 356px 0;

			.bind {
				margin-top: -240px;
				height: 42px;
				padding: 0 10px;
				background: rgba(0, 167, 60, 0.48);
				box-shadow: inset 0px 0 4px 0px rgba(255, 255, 255, 0.56);
				border-radius: 13px 13px 13px 13px;
				line-height: 42px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #FFFFFF;
			}

			.bg {
				margin-top: -80px;
				position: relative;
				z-index: 99;
				padding: 30px;
				border-radius: 30px 30px 0 0;
				background: linear-gradient(180deg, #C3FFD9 0%, #ECFAF1 4%, #FAFDFB 10%, #FFFFFF 100%);
				box-shadow: inset 0px 4 9px 0px rgba(255, 255, 255, 0.56);

				.code {
					margin: 20px 0;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 18px;
					color: #000000;

				}

				.ewm {
					margin-bottom: 30px;
					width: 196px;
					height: 196px;
				}

				.tip {
					margin-top: 30px;
					background: #F7F8F9;
					border-radius: 13px 13px 13px 13px;
					padding: 30px;

					.tit {
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 500;
						font-size: 16px;
						color: #333333;
					}

					.t {
						margin-top: 10px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 16px;
						color: #666666;
					}
				}

				.yq {
					padding: 20px 0;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 18px;
					color: #EACF8C;

					span {
						padding-left: 16px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 500;
						font-size: 18px;
						color: #D39D1A;
					}
				}

				.nitem {
					padding: 20px 0;
					border-bottom: 1px solid #EEEEEE;

					&:last-child {
						border-bottom: none;
					}

					.number {
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 16px;
						color: #000000;
					}

					.number2 {
						font-family: DINPro, DINPro;
						font-weight: bold;
						font-size: 18px;
						color: #333333;

						span {
							margin-left: 6px;
							font-family: HONOR Sans CN, HONOR Sans CN;
							font-weight: 400;
							font-size: 13px;
							color: #333333;
						}
					}
				}
			}
		}
	}
	.inviteBg{
		::v-deep .el-dialog__body {
			width: 438px;
		}
		
		/deep/ .el-dialog__header {
			padding: 0 !important;
		}
		
		/deep/ .el-dialog__body {
			padding: 0 !important;
		}
		
		::v-deep .el-dialog__close:hover {
			color: #999;
		}
	}

	.downbtn {
		position: absolute;
		right: -154px;
		top: 0;
		width: 129px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 11px 11px 11px 11px;
		display: flex;
		align-items: center;
		justify-content: center;

	}

	.shareBg {
		width: 438px;
		height: 667px;
		background-image: url('../../assets/images/haibao.png');
		background-size: 100%;
		padding-top: 300px;
		position: relative;

		.ewm {
			width: 298px;
			height: 298px;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 24px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.codeBox {
		padding-bottom: 30px;

		.tit {
			padding: 16px 0;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 20px;
			color: #000000;
		}

		input {
			margin: 20px 0;
			width: 90%;
			height: 53px;
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;
			border: none;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #000;

			&:focus {
				outline: none;
			}
		}
	}

	.login-btn {
		width: 384px;
		height: 46px;
		background: url('../../assets/images/login/loginbtn.png') no-repeat;
		background-size: 100% 100%;
		margin-top: 13px;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}
</style>